import {isPlainObject, isEmpty} from 'lodash';
import type {Context} from '../types';

/**
 * This patch moves Ecommerce bindings from node.data.commerce.bind to node.data.dyn.bind
 */

export default (context: Context) => {
  const {
    node: {
      jsonNode: {data: nodeData = {}, _id},
    },
  } = context;

  const commerceData = nodeData.commerce;
  const hasCorruptCommerceData = commerceData && !isPlainObject(commerceData);
  const hasEmptyCommerceData =
    commerceData && isPlainObject(commerceData) && isEmpty(commerceData);
  const commerceBindings = commerceData && commerceData.bind;

  const needed =
    hasCorruptCommerceData || hasEmptyCommerceData || commerceBindings;

  return {
    needed,
    logData: {
      msg: 'Moving commerce binding from `node.data.commerce.bind` to `node.data.dyn.bind`',
      meta: {
        nodeId: _id,
      },
    },
    apply: () => {
      if (hasCorruptCommerceData || hasEmptyCommerceData) {
        // eslint-disable-next-line webflow/no-delete
        delete nodeData.commerce;
        return;
      }

      const hasCorruptCommerceBindings =
        !isPlainObject(commerceBindings) || isEmpty(commerceBindings);

      if (hasCorruptCommerceBindings) {
        // Cannot delete nodeData.commerce.bind because:
        // • property bind is missing in undefined [1].
        // • property bind is missing in undefined [2].
        // • property bind is missing in undefined [3].
        delete nodeData.commerce.bind; // eslint-disable-line webflow/no-delete
        if (isEmpty(nodeData.commerce)) {
          // eslint-disable-next-line webflow/no-delete
          delete nodeData.commerce;
        }
        return;
      }

      if (!nodeData.dyn) {
        nodeData.dyn = {};
      }

      nodeData.dyn.bind = commerceBindings;

      // Cannot delete nodeData.commerce.bind because:
      // • property bind is missing in undefined [1].
      // • property bind is missing in undefined [2].
      // • property bind is missing in undefined [3].
      delete nodeData.commerce.bind; // eslint-disable-line webflow/no-delete
      if (isEmpty(nodeData.commerce)) {
        // eslint-disable-next-line webflow/no-delete
        delete nodeData.commerce;
      }
    },
  };
};
